import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../../components/Hero';
import TelecomLinkBoxRow from '../../components/TelecomLinkBoxRow';

export type NOM_196_SCFI_2016Props = {};

const NOM_196_SCFI_2016: React.FC<NOM_196_SCFI_2016Props> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/telecom-header-planet.png'} 
        heading={intl.formatMessage({
          id: "telecommunications",
          defaultMessage: "Telecommunications"
        })}
        subHeading='NOM-196-SCFI-2016'
      />
      <TelecomLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-16">
        <div className="flex w-full flex-col md:flex-row items-start justify-center">
          <div className="flex flex-col w-full md:w-1/2 lg:w-3/5 pt-0 md:pt-6 pb-10 md:pb-0 gap-10">
            <div className="">
              <h2 className='text-xl text-secondary font-bold mb-2'>
                NOM-196-SCFI-2016
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "term_equipment",
                    defaultMessage: "Terminal equipment that connects or interconnects through wired access to a public telecommunications network"
                  })
                }
              </p>
            </div>
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'scope',
                    defaultMessage: "Scope:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "products_terminal_equipment",
                    defaultMessage: "The products covered by this Official Mexican Standard are all terminal equipment that is connected or interconnected through wired access to the public telecommunications network."
                  })
                }
              </p>
            </div>
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'products_terminal_example',
                    defaultMessage: "Examples of equipment subject to compliance with the NOM:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "products_telephones",
                    defaultMessage: "Wired and cordless telephones with output for telephone lines, switches."
                  })
                }
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-2/5">
            <img src="/img/cord-phone-office.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NOM_196_SCFI_2016;